import React from 'react';

import { Box } from '@atlaskit/primitives/compiled/box';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';

export type PageIncludeErrorProps = {
	heading: React.ReactNode;
	body?: React.ReactNode;
};

export const PageIncludeError = ({ heading, body }: PageIncludeErrorProps): React.JSX.Element => (
	<Box paddingBlock="space.100" paddingInline="space.150" testId="page-include-error">
		<Stack space="space.050">
			<Text weight="bold">{heading}</Text>
			{body && <Text>{body}</Text>}
		</Stack>
	</Box>
);
